import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useSelector } from 'react-redux'

import type { LoggedUser, UserPermissions } from '@/api/auth/types/LoggedUser'
import { getCurrentUser } from '@/api/user/userService'
import { QUERY_KEYS } from '@/lib/queryKeys'
import type { RootState } from '@/store/store'

export const useCurrentUser = () => {
  const isAuthenticated = useSelector((state: RootState) => state.app.isAuthenticated)

  return useQuery({
    queryKey: [QUERY_KEYS.LOGGED_USER],
    enabled: isAuthenticated,
    queryFn: () => getCurrentUser(),
    retry(failureCount, error) {
      // Dont retry if the error is 401 or 403
      if (error instanceof AxiosError && (error.response?.status === 401 || error.response?.status === 403)) {
        return false
      }
      return failureCount < 2
    },
    select: data => {
      return {
        ...data,
        permissions: {
          ...data?.groups?.Groups.reduce((acc, group) => {
            acc[group.GroupName as keyof UserPermissions] = true
            return acc
          }, {} as UserPermissions),
        },
      } as LoggedUser
    },
  })
}
